export default __webpack_public_path__ + "static/media/arbitrum.aa33a75e.svg";